<template>
     <v-dialog
      v-model="visible"
      max-width="600px"
      @click:outside="closeDialog()"
    >
      <v-card>
        <v-card-title class="headline success--text text-center"> {{ title }}</v-card-title>

        <v-card-text>
            {{ message }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="closeDialog()"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: "success-dialog",
  data() {
    return {
    };
  },
  methods: {
    closeDialog() {
      this.$store.state.successDialogMessages = "";
      this.$store.state.successDialog = false;
    },
  },
   computed: {
    title() {
        return this.$store.state.successDialogTitle;
    },
    message() {
      return this.$store.state.successDialogMessage;
    },
    visible() {
      return this.$store.state.successDialog;
    }
  },
  created() {}
};
</script>

<style scoped>
  .v-card__text div {
    font-size: 16px;
  }
</style>